"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.setupLogger = void 0;
const winston = __importStar(require("winston"));
const safeStringify_1 = require("./safeStringify");
const loggerConfig_1 = require("./loggerConfig");
const bannedHeaders = {
    Authorization: undefined,
    authorization: undefined,
    ['client_secret']: undefined,
};
const preconfigureLogger = (logLevel) => winston.createLogger(Object.assign(Object.assign({}, loggerConfig_1.baseConfig), { level: logLevel || (0, loggerConfig_1.maxLogLevel)() }));
function buildLogger(logLevel) {
    const loggerConfig = preconfigureLogger(logLevel);
    return {
        [loggerConfig_1.LogLevel.CRIT]: loggerConfig.crit.bind(loggerConfig),
        [loggerConfig_1.LogLevel.ERROR]: loggerConfig.error.bind(loggerConfig),
        [loggerConfig_1.LogLevel.WARN]: loggerConfig.warn.bind(loggerConfig),
        [loggerConfig_1.LogLevel.INFO]: loggerConfig.info.bind(loggerConfig),
        [loggerConfig_1.LogLevel.DEBUG]: loggerConfig.debug.bind(loggerConfig),
    };
}
function trimHeaders(headers) {
    const head = Object.assign({}, headers);
    Object.keys(bannedHeaders).forEach((key) => {
        delete head[key];
    });
    return head;
}
function trimRequest(request = {}) {
    const { aborted, app, baseURL, baseUrl, body, data, headers, hostname, httpVersion, httpVersionMajor, httpVersionMinor, ip, ips, maxContentLength, maxRedirects, method, originalUrl, params, path, protocol, proxy, query, rawTrailers, readable, responseType, route, secure, socketPath, stale, statusCode, statusMessage, subdomains, timeout, timeoutErrorMessage, url, withCredentials, xhr, xsrfCookieName, xsrfHeaderName, } = request;
    return {
        aborted,
        app,
        baseURL,
        baseUrl,
        body,
        data,
        headers: trimHeaders(headers),
        hostname,
        httpVersion,
        httpVersionMajor,
        httpVersionMinor,
        ip,
        ips,
        maxContentLength,
        maxRedirects,
        method,
        originalUrl,
        params,
        path,
        protocol,
        proxy,
        query,
        rawTrailers,
        readable,
        responseType,
        route,
        secure,
        socketPath,
        stale,
        statusCode,
        statusMessage,
        subdomains,
        timeout,
        timeoutErrorMessage,
        url,
        withCredentials,
        xhr,
        xsrfCookieName,
        xsrfHeaderName,
    };
}
function trimResponse(response = {}) {
    const { charset, chunkedEncoding, config, data, finished, headers, headersSent, sendDate, shouldKeepAlive, status, statusCode, statusMessage, statusText, 
    // @ts-ignore
    upgrading, useChunkedEncodingByDefault, } = response;
    return {
        charset,
        chunkedEncoding,
        config,
        data,
        finished,
        headers: trimHeaders(headers),
        headersSent,
        sendDate,
        shouldKeepAlive,
        status,
        statusCode,
        statusMessage,
        statusText,
        // @ts-ignore
        upgrading,
        useChunkedEncodingByDefault,
    };
}
function buildStructuredLogger(interceptor = (msg) => msg, logLevel) {
    return Object.entries(buildLogger(logLevel)).reduce((acc, it) => {
        const key = it[0];
        acc[key] = (message, opt) => {
            if (typeof message === 'string') {
                message = Object.assign(Object.assign({}, opt), { message });
            }
            message = Object.assign(Object.assign({}, message), { request: (message === null || message === void 0 ? void 0 : message.request) && trimRequest(message === null || message === void 0 ? void 0 : message.request), response: (message === null || message === void 0 ? void 0 : message.response) && trimResponse(message === null || message === void 0 ? void 0 : message.response) });
            return it[1]((0, safeStringify_1.safeStringify)(interceptor(message, loggerConfig_1.LogLevel[key.toUpperCase()])));
        };
        return acc;
    }, {});
}
const container = {
    logLevel: (0, loggerConfig_1.maxLogLevel)(),
    logger: buildStructuredLogger(),
};
function setupLogger(logLevel = container.logLevel, interceptor = (msg) => msg) {
    logLevel = logLevel === null || logLevel === void 0 ? void 0 : logLevel.toLowerCase();
    container.logger = buildStructuredLogger(interceptor, logLevel);
    container.logLevel = logLevel;
    return container.logger;
}
exports.setupLogger = setupLogger;
function isActive(logLevel) {
    return Object.keys(container.logger).indexOf(logLevel) <= Object.keys(container.logger).indexOf(container.logLevel);
}
function buildLogWrapper(key) {
    // ts-ignore
    if (typeof global['window'] !== 'undefined') {
        return (...args) => {
            if (isActive(key)) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return container.logger[key](...args);
            }
            else {
                return {};
            }
        };
    }
    else {
        return (...args) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return container.logger[key](...args);
        };
    }
}
const _logger = {};
Object.keys(buildLogger()).forEach((key) => {
    _logger[key] = buildLogWrapper(key);
});
exports.logger = _logger;
